import { MutableRefObject, RefObject, useEffect } from 'react';

export const useTitleStateChange = (
  titleRef: MutableRefObject<HTMLElement | null>,
  wrapperRef?: RefObject<HTMLElement> | null,
  onTitleViewStateChange?: ({ isVisible }: { isVisible: boolean }) => void,
): void => {
  useEffect(() => {
    if (onTitleViewStateChange) {
      const callback = (entries) => {
        entries.forEach((entry) => {
          onTitleViewStateChange({ isVisible: entry.isIntersecting });
        });
      };

      const options = {
        root: wrapperRef?.current,
        rootMargin: '30px',
        threshold: 0,
      };
      const observer = new IntersectionObserver(callback, options);

      if (titleRef.current) {
        observer.observe(titleRef.current);
      }
    }
  }, [wrapperRef, titleRef, onTitleViewStateChange]);
};
